import axios from '../lib/axios';

export default async function getPaymentMethods() {
  const response = await axios
    .get(`/api/v1/payment-methods`)
    .then((res) => res)
    .catch((error) => {
      if (error.response.status !== 409) throw error;
    });

  return response.data;
}
